import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pUiVersionKontrol, rUiVersionKontrolSonuc, rValue } from '../../models/.catalog';

export default class UiVersionKontrolApi extends ApiBase<pUiVersionKontrol, rValue<rUiVersionKontrolSonuc>> {
    constructor(options?: Options) {
        super(
            new MethodInfo({
                MethodUrl: '/Kontrol',
            }),
            options
        );
        this._ServiceUrl = '/services/UiVersion.asmx';
    }
}